import React, { useMemo } from "react";
import { Text } from "@evvve/ui-kit";

import { ModalTemplate } from "src/close-part/features/Modals";
import { ModalTemplateProps } from "src/close-part/features/Modals/ModalTemplate";
import { deleteDialogStatics, leaveGroupStatics } from "src/constants";
import { DialogType } from "../../types";
import avatar_skeleton from "src/assets/images/avatar_skeleton.png";
import event_group_chat from "src/assets/icons/event_group_chat.svg";

import styles from "./style.module.scss";

type Statics = {
  title: string;
  caption: string;
  defaultAvatar: string;
}

const QuitChatStatics: Record<DialogType, Statics> = {
  [DialogType.Personal]: { ...deleteDialogStatics, defaultAvatar: avatar_skeleton },
  [DialogType.Group]: { ...leaveGroupStatics, defaultAvatar: event_group_chat },
};

type Props = {
  dialogType: DialogType;
  dialogAvatarUrl?: string;
  dialogCaption?: string;
  onClose?: () => void;
};

export default function QuitChatModal({
  dialogType,
  dialogAvatarUrl,
  dialogCaption,
  buttons,
  onClose,
}: Props & Pick<ModalTemplateProps, "buttons">) {

  const currentStatics = useMemo(() => QuitChatStatics[dialogType], [dialogType]);

  return <ModalTemplate
    isOpen={true}
    onClose={onClose || (() => void 0)}
    buttons={buttons}
    title={currentStatics.title}
    description={currentStatics.caption}
    className={styles.modalWrap}
  >
    {dialogCaption && <div className={styles.dialogDescriptionWrap}>
      <img src={dialogAvatarUrl || currentStatics.defaultAvatar} />
      <Text size="m" color="grayscale900">{dialogCaption}</Text>
    </div>}
  </ModalTemplate>;
}
